/* Pastilou – comportements des sections landing */
(function () {
  'use strict';
  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* ----- Comptes à rebours (fin de journée Paris ou date fixe) ----- */
  function endTime(el) {
    if (el.dataset.mode === 'date') {
      var t = Date.parse(el.dataset.end || '');
      return isNaN(t) ? null : t;
    }
    var now = new Date();
    var secs = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
    try {
      var parts = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(now);
      var g = function (type) { var p = parts.find(function (x) { return x.type === type; }); return p ? parseInt(p.value, 10) : 0; };
      secs = (g('hour') % 24) * 3600 + g('minute') * 60 + g('second');
    } catch (e) {}
    return now.getTime() + (86400 - secs) * 1000;
  }

  function initCountdowns(root) {
    root.querySelectorAll('[data-pt-countdown]').forEach(function (el) {
      if (el.__pt) return; el.__pt = true;
      var tick = function () {
        var end = endTime(el);
        var left = end ? Math.max(0, Math.floor((end - Date.now()) / 1000)) : 0;
        if (el.dataset.mode === 'date' && (!end || left <= 0)) {
          var wrap = el.closest('[data-pt-countdown-wrap]') || el;
          wrap.hidden = true;
          return;
        }
        var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
        el.querySelectorAll('[data-d]').forEach(function (x) { x.textContent = pad(d); });
        el.querySelectorAll('[data-dbox]').forEach(function (x) { x.hidden = d < 1; });
        el.querySelectorAll('[data-h]').forEach(function (x) { x.textContent = pad(h); });
        el.querySelectorAll('[data-m]').forEach(function (x) { x.textContent = pad(m); });
        el.querySelectorAll('[data-s]').forEach(function (x) { x.textContent = pad(s); });
        el.querySelectorAll('[data-text]').forEach(function (x) { x.textContent = (d > 0 ? d + ' j ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s); });
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ----- Ajout au panier (actions Shopify -> tiroir Horizon, sinon /cart) ----- */
  function addToCart(variantId, quantity) {
    var A = window.Shopify && window.Shopify.actions;
    var classic = function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Erreur'); });
        window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
      });
    };
    if (A && A.updateCart) {
      return A.updateCart(
        { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: quantity }] },
        { event: { context: 'product' } }
      ).then(function (res) {
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
        if (A.openCart) return A.openCart();
      }).catch(function (err) { console.warn('[pt] updateCart', err); return classic(); });
    }
    return classic();
  }

  function initBuy(root) {
    root.querySelectorAll('[data-pt-buy]').forEach(function (box) {
      if (box.__pt) return; box.__pt = true;
      var inputs = Array.prototype.slice.call(box.querySelectorAll('input[name="id"]'));
      var btn = box.querySelector('[data-pt-atc]');
      var priceEl = box.querySelector('[data-pt-atc-price]');
      var err = box.querySelector('[data-pt-error]');
      var update = function () {
        var sel = inputs.find(function (i) { return i.checked; }) || inputs[0];
        if (!sel) return;
        var tier = Number(sel.dataset.tier || 1);
        inputs.forEach(function (i) { i.closest('.pt-tier').classList.toggle('is-on', i === sel); });
        box.querySelectorAll('[data-unlock]').forEach(function (b) { b.classList.toggle('is-locked', tier < Number(b.dataset.unlock)); });
        if (priceEl) priceEl.textContent = sel.dataset.price ? '— ' + sel.dataset.price : '';
      };
      inputs.forEach(function (i) { i.addEventListener('change', update); });
      update();
      var form = box.querySelector('form');
      if (form && btn) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var sel = inputs.find(function (i) { return i.checked; }) || inputs[0];
          if (!sel) return;
          btn.disabled = true; btn.classList.add('is-loading');
          if (err) err.hidden = true;
          addToCart(sel.value, 1).catch(function (ex) {
            if (err) { err.textContent = ex.message || 'Impossible d\'ajouter au panier.'; err.hidden = false; }
          }).then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
        });
      }
    });
  }

  /* ----- Galerie produit ----- */
  function initGallery(root) {
    root.querySelectorAll('[data-pt-gallery]').forEach(function (g) {
      if (g.__pt) return; g.__pt = true;
      var main = g.querySelector('.pt-gal__img');
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
      var count = g.querySelector('[data-gal-count]');
      var cur = 0;
      function show(i) {
        if (!thumbs.length) return;
        cur = (i + thumbs.length) % thumbs.length;
        var t = thumbs[cur];
        if (main) { main.src = t.dataset.src; main.removeAttribute('srcset'); main.alt = t.dataset.alt || ''; }
        thumbs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
        if (count) count.textContent = (cur + 1) + ' / ' + thumbs.length;
        var c = t.parentNode;
        if (c && c.scrollWidth > c.clientWidth) c.scrollTo({ left: t.offsetLeft - c.offsetLeft - (c.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = g.querySelector('[data-gal-prev]'), next = g.querySelector('[data-gal-next]');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); });
      if (next) next.addEventListener('click', function () { show(cur + 1); });
      var box = g.querySelector('.pt-gal__main'), x0 = null, y0 = 0;
      if (box && thumbs.length > 1) {
        box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        box.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    });
  }

  /* ----- Avis : filtres + "voir plus" ----- */
  function initReviews(root) {
    root.querySelectorAll('[data-pt-reviews]').forEach(function (s) {
      if (s.__pt) return; s.__pt = true;
      var cards = Array.prototype.slice.call(s.querySelectorAll('[data-cat]'));
      var more = s.querySelector('[data-more]');
      var limit = Number(s.dataset.limit) || 9;
      var filter = 'all', expanded = false;
      var render = function () {
        var count = 0;
        cards.forEach(function (c) {
          var ok = filter === 'all' || c.dataset.cat === filter;
          if (ok) count++;
          c.hidden = !(ok && (expanded || count <= limit));
        });
        if (more) more.hidden = expanded || count <= limit;
      };
      s.querySelectorAll('[data-filter]').forEach(function (b) {
        b.addEventListener('click', function () {
          filter = b.dataset.filter;
          s.querySelectorAll('[data-filter]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
          render();
        });
      });
      if (more) more.addEventListener('click', function () { expanded = true; render(); });
      render();
    });
  }

  /* ----- Témoignages (pastilles rondes) ----- */
  function initTestimonials(root) {
    root.querySelectorAll('[data-pt-tslider]').forEach(function (s) {
      if (s.__pt) return; s.__pt = true;
      var dots = Array.prototype.slice.call(s.querySelectorAll('[data-dot]'));
      var slides = Array.prototype.slice.call(s.querySelectorAll('[data-slide]'));
      if (!slides.length) return;
      var i = 0, timer;
      var go = function (n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (x, k) { x.hidden = k !== i; });
        dots.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
      };
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); clearInterval(timer); }); });
      go(0);
      if (slides.length > 1) timer = setInterval(function () { go(i + 1); }, 6000);
    });
  }

  /* ----- Avant / après ----- */
  function initBeforeAfter(root) {
    root.querySelectorAll('[data-pt-ba]').forEach(function (b) {
      if (b.__pt) return; b.__pt = true;
      var r = b.querySelector('input[type="range"]');
      if (!r) return;
      var set = function () { b.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set); set();
    });
  }

  /* ----- Carrousel vidéos : carte centrale mise en avant ----- */
  function initCarousel(root) {
    root.querySelectorAll('[data-pt-carousel]').forEach(function (c) {
      if (c.__pt) return; c.__pt = true;
      var stage = c.querySelector('[data-track]');
      var cards = stage ? Array.prototype.slice.call(stage.querySelectorAll('[data-card]')) : [];
      var n = cards.length;
      if (!n) return;
      var active = Math.floor((n - 1) / 2);
      function render() {
        cards.forEach(function (card, i) {
          var d = i - active;
          if (n >= 3) { if (d * 2 > n) d -= n; if (d * 2 < -n) d += n; }
          var pos = d === 0 ? 'c' : d === -1 ? 'l' : d === 1 ? 'r' : (d < 0 ? 'fl' : 'fr');
          card.setAttribute('data-pos', pos);
          if (pos === 'fl' || pos === 'fr') card.setAttribute('inert', ''); else card.removeAttribute('inert');
        });
      }
      function go(i) {
        active = ((i % n) + n) % n;
        c.querySelectorAll('video').forEach(function (v) { v.pause(); });
        render();
      }
      c.__ptGo = function (card) { var i = cards.indexOf(card); if (i > -1) go(i); };
      c.querySelectorAll('[data-dir]').forEach(function (a) {
        if (n < 2) { a.hidden = true; return; }
        a.addEventListener('click', function () { go(active + Number(a.dataset.dir)); });
      });
      cards.forEach(function (card, i) {
        card.addEventListener('click', function (e) {
          if (i !== active) { e.preventDefault(); go(i); }
        });
      });
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40 && n > 1) go(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
      render();
      c.querySelectorAll('video').forEach(function (v) {
        v.addEventListener('play', function () {
          c.querySelectorAll('video').forEach(function (o) { if (o !== v) o.pause(); });
          var p = v.parentElement.querySelector('.pt-ugc__play'); if (p) p.hidden = true;
        });
      });
    });
  }

  /* ----- Date de livraison estimée (jours ouvrés, fériés FR exclus) ----- */
  function frHolidays(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    var easter = new Date(y, mo - 1, da);
    var plus = function (n) { var x = new Date(easter); x.setDate(x.getDate() + n); return x; };
    return [new Date(y, 0, 1), new Date(y, 4, 1), new Date(y, 4, 8), new Date(y, 6, 14), new Date(y, 7, 15),
      new Date(y, 10, 1), new Date(y, 10, 11), new Date(y, 11, 25), plus(1), plus(39), plus(50)]
      .map(function (x) { return x.toDateString(); });
  }
  function addBusinessDays(start, n) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate()), cache = {};
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var y = d.getFullYear(); cache[y] = cache[y] || frHolidays(y);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6 && cache[y].indexOf(d.toDateString()) < 0) n--;
    }
    return d;
  }
  function initEta(root) {
    root.querySelectorAll('[data-pt-eta]').forEach(function (el) {
      if (el.__pt) return; el.__pt = true;
      var min = Number(el.dataset.min), max = Number(el.dataset.max), tpl = el.dataset.template || '';
      var out = el.querySelector('[data-text]');
      if (!out || !tpl || !min || !max || max < min || tpl.indexOf('[min]') < 0 || tpl.indexOf('[max]') < 0) return;
      try {
        var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
        var now = new Date();
        var dates = { '[min]': fmt.format(addBusinessDays(now, min)), '[max]': fmt.format(addBusinessDays(now, max)) };
        out.textContent = '';
        tpl.split(/(\[min\]|\[max\])/).forEach(function (part) {
          if (dates[part]) { var b = document.createElement('b'); b.textContent = dates[part]; out.appendChild(b); }
          else if (part) out.appendChild(document.createTextNode(part));
        });
      } catch (e) { /* on garde le texte de secours */ }
    });
  }

  /* ----- Outil « Combien de boîtes vous faut-il ? » ----- */
  function initQuiz(root) {
    root.querySelectorAll('[data-pt-quiz]').forEach(function (q) {
      if (q.__pt) return; q.__pt = true;
      var box = q.closest('[data-pt-buy]');
      var per = Number(q.dataset.perBox) || 12;
      var boxes = (q.dataset.boxes || '1,2,4').split(',').map(function (x) { return Number(x) || 1; });
      var res = q.querySelector('[data-res]');
      var ans = {};
      var target = Number(q.dataset.target) || 6;
      var dur = function (months) {
        if (months < 2) { var w = Math.max(1, Math.round(months * 4.345)); return w + (w > 1 ? ' semaines' : ' semaine'); }
        return Math.round(months) + ' mois';
      };
      var add = function (parent, text, bold) {
        var n = bold ? document.createElement('b') : document.createTextNode(text);
        if (bold) n.textContent = text;
        parent.appendChild(n);
      };
      q.querySelectorAll('[data-q]').forEach(function (group) {
        group.querySelectorAll('button').forEach(function (btn) {
          btn.setAttribute('aria-pressed', 'false');
          btn.addEventListener('click', function () {
            group.querySelectorAll('button').forEach(function (o) {
              o.classList.toggle('is-on', o === btn);
              o.setAttribute('aria-pressed', o === btn ? 'true' : 'false');
            });
            ans[group.dataset.q] = Number(btn.dataset.v);
            if (ans.f === undefined || ans.i === undefined || !res) return;
            var perMonth = ans.f, initial = ans.i;
            var inputs = box ? Array.prototype.slice.call(box.querySelectorAll('input[name="id"]')) : [];
            if (!inputs.length) return;
            var months = function (k) { return Math.max(0, (boxes[k] || 1) * per - initial) / perMonth; };
            var rec = inputs.length;
            for (var k = 0; k < inputs.length; k++) { if (months(k) >= target) { rec = k + 1; break; } }
            var input = inputs[rec - 1];
            res.textContent = '';
            add(res, 'Pour votre foyer, nous conseillons environ ');
            add(res, perMonth + ' cycles par mois', true);
            add(res, initial ? ', après un grand nettoyage de départ (' + initial + ' pastilles). ' : '. ');
            add(res, '1 boîte vous dure environ ');
            add(res, dur(months(0)), true);
            add(res, '. Notre conseil : ');
            add(res, input.dataset.title || '', true);
            add(res, ', soit environ ');
            add(res, dur(months(rec - 1)), true);
            add(res, " d'entretien. Elle est sélectionnée ci-dessous.");
            res.hidden = false;
            if (!input.disabled && !input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      });
    });
  }

  /* ----- Barre d'achat collante (mobile) ----- */
  function initSticky(root) {
    root.querySelectorAll('[data-pt-sticky]').forEach(function (bar) {
      if (bar.__pt) return; bar.__pt = true;
      var scope = bar.parentElement || document;
      var box = scope.querySelector('[data-pt-buy]');
      var atc = box && box.querySelector('[data-pt-atc]');
      var btn = bar.querySelector('[data-pt-sticky-btn]');
      if (!atc || !btn) return;
      var tierEl = bar.querySelector('[data-pt-sticky-tier]');
      var priceEl = bar.querySelector('[data-pt-sticky-price]');
      var inputs = Array.prototype.slice.call(box.querySelectorAll('input[name="id"]'));
      var sync = function () {
        var sel = inputs.find(function (i) { return i.checked; }) || inputs[0];
        if (!sel) return;
        if (tierEl) tierEl.textContent = sel.dataset.title || '';
        if (priceEl) priceEl.textContent = sel.dataset.price ? '— ' + sel.dataset.price : '';
      };
      inputs.forEach(function (i) { i.addEventListener('change', sync); });
      sync();
      btn.addEventListener('click', function () { atc.click(); });
      var ticking = false;
      var check = function () {
        ticking = false;
        var show = atc.getBoundingClientRect().bottom < 0;
        if (show === bar.classList.contains('is-on')) return;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        btn.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(check); }
      }, { passive: true });
      window.addEventListener('resize', check);
      check();
    });
  }

  /* ----- Suivi de colis (numéro de suivi -> 17TRACK) ----- */
  function initTracking(root) {
    root.querySelectorAll('[data-pt-track]').forEach(function (f) {
      if (f.__pt) return; f.__pt = true;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var n = (f.querySelector('input') || {}).value;
        n = (n || '').trim();
        if (n) window.open('https://t.17track.net/fr#nums=' + encodeURIComponent(n), '_blank', 'noopener');
      });
    });
  }

  /* ----- « Ce qui rend Pastilou différent » : grille 2 x 2 tout ouverte sur ordinateur, accordéon sur téléphone ----- */
  function initDiffGrid(root) {
    var mq = window.matchMedia('(min-width: 990px)');
    root.querySelectorAll('[data-pt-diff-list]').forEach(function (list) {
      if (list.__pt) return; list.__pt = true;
      var items = Array.prototype.slice.call(list.querySelectorAll('details'));
      items.forEach(function (d) {
        if (d.getAttribute('name')) d.dataset.name = d.getAttribute('name');
        var sm = d.querySelector('summary');
        if (sm) sm.addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
      });
      function apply() {
        items.forEach(function (d, i) {
          if (mq.matches) { d.removeAttribute('name'); d.open = true; }
          else { d.open = i === 0; if (d.dataset.name) d.setAttribute('name', d.dataset.name); }
        });
      }
      apply();
      if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
    });
  }

  /* ----- Carte offre de l'accueil : photos qui défilent (glisser, points, défilement auto) ----- */
  function initOfferSlides(root) {
    root.querySelectorAll('[data-pt-slides]').forEach(function (box) {
      if (box.__pt) return; box.__pt = true;
      var track = box.querySelector('[data-track]');
      var slides = box.querySelectorAll('[data-slide]');
      var dots = Array.prototype.slice.call(box.querySelectorAll('[data-dot]'));
      if (!track || slides.length < 2) return;
      var cur = 0, timer = null, stopped = false, visible = false;
      function setDot(i) { cur = i; dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
      function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); setDot(i); }
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== cur) setDot(Math.max(0, Math.min(slides.length - 1, i)));
      }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { stop(); go(k); }); });
      function stop() { stopped = true; if (timer) { clearInterval(timer); timer = null; } }
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, stop, { passive: true }); });
      function start() { if (stopped || timer || !visible) return; timer = setInterval(function () { go((cur + 1) % slides.length); }, 3500); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          visible = es[0].isIntersecting;
          if (visible) start(); else if (timer) { clearInterval(timer); timer = null; }
        }, { threshold: 0.5 }).observe(box);
      } else { visible = true; start(); }
    });
  }

  /* ----- Panier : passer à l'offre supérieure, ajouter le gant (délégation, le tiroir est re-rendu) ----- */
  var srPromise = null;
  function getSectionRenderer() {
    if (window.__ptSR) return Promise.resolve(window.__ptSR);
    if (srPromise) return srPromise;
    srPromise = new Promise(function (resolve, reject) {
      var done = function () { window.removeEventListener('pt:sr', done); window.__ptSR ? resolve(window.__ptSR) : reject(new Error('sr')); };
      window.addEventListener('pt:sr', done);
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = "import { sectionRenderer } from '@theme/section-renderer'; window.__ptSR = sectionRenderer; window.dispatchEvent(new Event('pt:sr'));";
      document.head.appendChild(s);
      setTimeout(function () { if (!window.__ptSR) { srPromise = null; reject(new Error('sr-timeout')); } }, 5000);
    });
    return srPromise;
  }
  function refreshCart() {
    return getSectionRenderer().then(function (sr) { return { sectionRenderer: sr }; }).then(function (m) {
      var comps = Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'));
      if (!comps.length) throw new Error('no-section');
      return Promise.all(comps.map(function (c) {
        return m.sectionRenderer.renderSection(c.dataset.sectionId, { cache: false, mode: c.closest('#cart-drawer') ? 'hydration' : 'full' });
      }));
    }).then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) { el.textContent = c.item_count; el.classList.toggle('hidden', !c.item_count); });
        document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', !c.item_count); });
      }).catch(function () {});
    });
  }
  function cartPost(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var up = t.closest('[data-pt-tierup]');
    var gl = !up && t.closest('[data-pt-upsell]');
    if (!up && !gl) return;
    e.preventDefault();
    var btn = up || gl;
    if (btn.disabled) return;
    btn.disabled = true;
    var req;
    if (up) {
      var updates; try { updates = JSON.parse(btn.getAttribute('data-pt-tierup')); } catch (err) { btn.disabled = false; return; }
      req = cartPost('/cart/update.js', { updates: updates });
    } else {
      req = cartPost('/cart/add.js', { items: [{ id: Number(btn.getAttribute('data-pt-upsell')), quantity: 1 }] });
    }
    req.then(refreshCart).catch(function () { window.location.reload(); });
  });

  /* Le gant n'est vendu qu'avec des pastilles : s'il reste seul, on le retire */
  var orphanBusy = false;
  function checkOrphan() {
    if (orphanBusy) return;
    var el = document.querySelector('[data-pt-orphan]');
    if (!el) return;
    orphanBusy = true;
    var keys = Array.prototype.slice.call(document.querySelectorAll('[data-pt-orphan]')).map(function (x) { return x.getAttribute('data-pt-orphan'); });
    var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
    cartPost('/cart/update.js', { updates: updates }).then(refreshCart).catch(function () {}).then(function () { orphanBusy = false; });
  }
  if ('MutationObserver' in window) {
    var orphanQueued = false;
    new MutationObserver(function () { if (orphanQueued) return; orphanQueued = true; setTimeout(function () { orphanQueued = false; checkOrphan(); }, 300); }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', checkOrphan);

  function init(root) {
    root = root || document;
    initDiffGrid(root); initOfferSlides(root);
    initCountdowns(root); initBuy(root); initGallery(root); initReviews(root);
    initTestimonials(root); initBeforeAfter(root); initCarousel(root); initTracking(root); initEta(root); initQuiz(root); initSticky(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest && e.target.closest('[data-card]');
    var c = card && card.closest('[data-pt-carousel]');
    if (c && c.__ptGo) c.__ptGo(card);
  });
})();
